// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getProducts: '/catalog/product',
  opProduct: '/catalog/product',
}

// get Products
export async function getProducts(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getProducts
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`
        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo productos',
        description: error.message,
      })
    })
}

// add new product
export async function postProduct(token, product) {
  const url = fsConfig.root + fsConfig.opProduct
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .post(url, product, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando producto',
        description: error.message,
      })
    })
}

export async function putProduct(token, product) {
  const url = fsConfig.root + fsConfig.opProduct
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = product
  delete product.key
  return axios
    .put(url, product, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      response.key = key
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando producto',
        description: error.message,
      })
    })
}

export async function deleteProduct(token, productUid) {
  const url = `${fsConfig.root}${fsConfig.opProduct}/${productUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando producto',
        description: error.message,
      })
    })
}
